<script>
    import Icon from 'svelte-awesome';
    import { cut } from 'svelte-awesome/icons';
    import { faBuilding} from '@fortawesome/free-regular-svg-icons';

    const services = [
        {
            title: "Hair",
            servicesList: ["Women’s & Men's Cuts", "Women’s & Men's Color", "Extensions", "Women’s Balayage"],
            backgroundImage: "images/welcome-stylist.jpg"

        },
        {
            title: "Makeup",
            servicesList: ["Regular Makeup", "Quick Fix Makeup", "Just Eyes", "Bridal Trial"],
            backgroundImage: "images/makeup-background.jpg"
        },
        {
            title: "Eye Lashes",
            servicesList: ["Lash Extensions", "Lash Lift & Tint", "Keratin", "Microblading"],
            backgroundImage: "images/lashes-background.jpg"
        }
    ];

</script>

<div id="Services" class="container">
    <h2 class="center section-title">Our <span class="emphasis">Services</span> <Icon class="section-title-icon" data={faBuilding} style="height: 40px; width: 40px;"/></h2>
    <div class="flex-row space-around">
    {#each services as service(service)}
        <div class="services-blocks">
            <div class="services-inner">
                <h3 class="services-title">{service.title}</h3>
                <ul>
                    {#each service.servicesList as item}
                        <li>{item}</li>
                    {/each}
                </ul>
            </div>
        </div>
    {/each}
    </div>
</div>